import React, { useState, useEffect } from "react";
import { Empty, Select } from "antd";


import { Card, Col, Row, Tooltip,  Tabs } from "antd";
import ColumnChart from "../charts/ColumnChart";
import DoughNutChart from "../charts/DoughnutChart";
import PieChart from "../charts/PieChart";
import CitizenScienceProvinceMap from "../charts/CitizenScienceProvinceMap";
import CitizenScienceDistrictMap from "../charts/CitizenScienceDistrictMap";

import Legend from "../charts/Legend";
import { util } from "../../utils/functions/custom";

import "antd/dist/reset.css";
import { InfoCircleTwoTone } from "@ant-design/icons";

import { ReportTemplate } from "../custom/ReportTemplate";
import { ReportButtons } from "../custom/ReportButtons";
import { reportTypeEnum } from "../custom/AppEnums";
import BarChart from "../charts/BarChart";
import DualAxesChart from "../charts/DualAxesChart";
import vsApi from "../../services/volunteerScientistAnalyticsService";
import { recordError } from "src/utils/logService";

export const VolunteerScientistReport = (props) => {
  const { filterType } = props;

  const [volunteerOccupation, setVolunteerOccupation] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [volunteerRoles, setVolunteerRoles] = useState([]);
  const [volunteerMotivationData, setVolunteerMotivationData] = useState([]);
  const [volunteerGrowth, setVolunteerGrowth] = useState([]);
  const [ageRangeData, setAgeRangeData] = useState([]);
  const [raceData, setRaceData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [disabilityData, setDisabilityData] = useState([]);
  const [languagesData, setLanguagesData] = useState([])
  const [volunteerProvincialData, setVolunteerProvincialData] = useState([]);
  const [volunteerDistrictData, setVolunteerDistrictData] = useState([]);
  const [volunteerQualificationData, setVolunteerQualificationData] = useState([]);
  const [initialised, setInitialised] = useState(false);
  const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());
  const [financialYears, setFinancialYears] = useState(
    util.getCurrentFinancialYear()
  );
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [filterId, setFilterId] = useState();
  const [show, setShow] = useState(false);
  const [isGeo, setIsGeo] = useState(false);

  const [reportOutProps, setReportOutProps] = useState({
    data: [],
    color: "",
    type: "",
    year: 0,
    description: "",
    xLabel: "",
    yLabel: "",
  });

  const { Option } = Select;
  const volunteerProvincialDistribution = "Distribution of Volunteer Scientists by Province";
  const volunteerDistrictDistribution =
    "Distribution of Volunteer Scientists by Municipal District";
 

  useEffect(() => {
 if (!initialised) {
      setFinancialYears(util.getCurrentFinancialYear());
      util.getYearsWithReports(vsApi, setFinancialYears, setReportYear);
      setInitialised(true);
    }

    setStartDate(reportYear);
    setEndDate(reportYear);
    initiateReportData(reportYear);
  }, [filterType,reportYear]);

  const initiateReportData = (repYear) => {
    getVolunteerDemographicsDisability(repYear);
    getVolunteerDemographicsGender(repYear);
    getVolunteerDemographicsRace(repYear);
    getVolunteerProvincial(repYear);
    getVolunteerMunicipal(repYear);
    getVolunteerDemographicAgeRange(repYear, -1);
    getVolunteerDemographicsLanguages(repYear, -1);
  };

  const getvolunteerMotivationData = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerMotivations(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerMotivationData(data);
      } else {
        setVolunteerMotivationData([]);
      }
    } catch (error) {
      setVolunteerMotivationData([]);
      recordError(error);
    }
  };

  const getVolunteerRole = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerRoles(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerRoles(data);
      } else {
        setVolunteerRoles([]);
      }
    } catch (error) {
      setVolunteerRoles([]);
      recordError(error);
    }
  };

   const getVolunteerOccupation = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerOccupations(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerOccupation(data);
      } else {
        setVolunteerOccupation([]);
      }
    } catch (error) {
      setVolunteerOccupation([]);
      recordError(error);
    }
  };

  const getVolunteerSectors = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerSectors(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setSectorData(data);
      } else {
        setSectorData([]);
      }
    } catch (error) {
      setSectorData([]);
      recordError(error);
    }
  };

   const getVolunteerDemographicsDisability = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDemographicsDisability(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setDisabilityData(data);
      } else {
        setDisabilityData([]);
      }
    } catch (error) {
      setDisabilityData([]);
      recordError(error);
    }
  };

  const getVolunteerDemographicsGender = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDemographicsGender(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setGenderData(data);
      } else {
        setGenderData([]);
      }
    } catch (error) {
      setGenderData([]);
      recordError(error);
    }
  };

  const getVolunteerDemographicsRace = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDemographicsRace(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setRaceData(data);
      } else {
        setRaceData([]);
      }
    } catch (error) {
      setRaceData([]);
      recordError(error);
    }
  };

  const getVolunteerDemographicAgeRange = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDemographicsAgeRange(year, filterId, "age-range");
      if (response && response.status === 200) {
        const { data } = response;
        setAgeRangeData(data);
      } else {
        setAgeRangeData([]);
      }
    } catch (error) {
      setAgeRangeData([]);
      recordError(error);
    }
  };

  const getVolunteerDemographicsLanguages = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDemographicsLanguages(year, filterId, "type");
      if (response && response.status === 200) {
        const { data } = response;
        setLanguagesData(data);
      } else {
        setLanguagesData([]);
      }
    } catch (error) {
      setLanguagesData([]);
      recordError(error);
    }
  };

 const getVolunteerProvincial = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerProvinces(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerProvincialData(data);
      } else {
        setVolunteerProvincialData([]);
      }
    } catch (error) {
      setVolunteerProvincialData([]);
      recordError(error);
    }
  };

   const getVolunteerMunicipal = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerDistricts(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerDistrictData(data);
      } else {
        setVolunteerDistrictData([]);
      }
    } catch (error) {
      setVolunteerDistrictData([]);
      recordError(error);
    }
  };

  const getVolunteerScienceGrowth = async (year, filterId) => {
    try {
      let newData = {};
      const response = await vsApi.getVolunteerGrowth(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        let total = 0;
        let totalPerc = 0;

        const { data } = response;
        data.forEach((item) => {
          total += item.value;
          totalPerc += item.percent;

          newData = {
            type: "Total",
            percent: totalPerc,
            value: total,
            year: item.year,
          };
        });

        const sorted = data?.sort((a, b) => {
          if (a.type > b.type) return -1;
          if (a.type < b.type) return 1;
          return 0;
        }) || [];

        const updatedData = [...sorted, newData];
        setVolunteerGrowth(updatedData);
      } else {
        setVolunteerGrowth([]);
      }
    } catch (error) {
      setVolunteerGrowth([]);
      recordError(error);
    }
  };

  const getVolunteerQualification = async (year, filterId) => {
    try {
      const response = await vsApi.getVolunteerQualifications(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setVolunteerQualificationData(data);
      } else {
        setVolunteerQualificationData([]);
      }
    } catch (error) {
      setVolunteerQualificationData([]);
      recordError(error);
    }
  };

  const updateAnalytics = (repYear, filterId) => {
    getVolunteerDemographicsDisability(repYear, filterId);
    getVolunteerDemographicsGender(repYear, filterId);
    getVolunteerDemographicsRace(repYear, filterId);
    getVolunteerScienceGrowth(repYear);
    getVolunteerProvincial(repYear, filterId);
    getVolunteerMunicipal(repYear, filterId);
    getVolunteerDemographicAgeRange(repYear, filterId);
    getVolunteerDemographicsLanguages(repYear, filterId);
    getVolunteerRole(repYear, filterId);
    getvolunteerMotivationData(repYear, filterId);
    getVolunteerOccupation(repYear, filterId);
    getVolunteerSectors(repYear, filterId);
    getVolunteerQualification(repYear, filterId);
  };

  const onYearChange = (value) => {
    setReportYear(value);
    updateAnalytics(value, filterId);
  };

  const handlePrint = (
    color,
    data,
    // colorField,
    type,
    desc,
    title,
    xLabel = "None",
    yLabel = "None",
    seriesField = "None",
    // isStack = false,
    stack = false,
    xField = "None",
    yField = "None"
  ) => {
    const rptProps = { ...reportOutProps };
    rptProps.color = color;
    // rptProps.colorField = colorField;
    rptProps.data = data;
    rptProps.type = type;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.description = desc;
    rptProps.title = title;
    rptProps.xLabel = xLabel;
    rptProps.yLabel = yLabel;
    // rptProps.colorField = colorField;
    rptProps.seriesField = seriesField;
    // rptProps.isStack = isStack;
    rptProps.stack = stack;
    rptProps.xField = xField;
    rptProps.yField = yField;
    rptProps.module = "VSCI";

    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(false);
  };

  const handleGeoPrint = (title, description, data, geoType, dataSource) => {
    const rptProps = { ...reportOutProps };
    rptProps.title = title;
    rptProps.description = description;
    rptProps.color = undefined;
    rptProps.data = data;
    rptProps.type = geoType;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.dataSource = dataSource;

    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(true);
  };

  const handlePrintCancel = () => {
    setShow(false);
    setIsGeo(false);
    const rptProps = { ...reportOutProps };
    rptProps.title = "";
    rptProps.description = "";
    rptProps.color = undefined;
    // rptProps.colorField = undefined;
    rptProps.data = [];
    rptProps.type = undefined;
    rptProps.year = 0;
    rptProps.dataSource = "";
    setReportOutProps(rptProps);
  };

  const handleDataDownload = (data, filename, chartType) => {
    let csvContent;

    if (chartType === reportTypeEnum.GROUPCOL) {
      const groupedData = util.groupDataByType(data, reportYear);

      csvContent =
        "data:text/csv;charset=utf-8," +
        util.convertArrayDataToCSV(groupedData);
    } else {
      csvContent =
        "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
    }

    const encodedURI = encodeURI(csvContent);

    //Allow the selected to be downloadable through an anchor popup
    const link = document.createElement("a");
    link.setAttribute("href", encodedURI);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function Tab1() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12}>
            <Card
              title="Race"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of volunteer scientists, based on race">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                raceData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceDoughnut",
                        raceData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of volunteer scientists, based on race.",
                        "Volunteer Scientists Race Distribution",
                        "Volunteer Scientists per race",
                        "Percentage per volunteer scientist race"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        raceData,
                        "Volunteer Scientists Race Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {raceData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={raceData.filter((item) => item.value > 0)}
                  color="raceDoughnut"
                  type="Race"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Gender"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of volunteer scientists, based on gender">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                genderData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "csGender",
                        genderData,
                        reportTypeEnum.PIE,
                        "Demographic analysis of volunteer scientists, based on gender.",
                        "Volunteer Scientists Gender"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        genderData,
                        "Volunteer Scientists Gender Groups",
                        reportTypeEnum.PIE
                      )
                    }
                  />,
                ]
              }
            >
              {genderData.length === 0 ? (
                <Empty />
              ) : (
                <PieChart
                  data={genderData.filter((item) => item.value > 0)}
                  color="csGender"
                  type="Gender"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={24}>
            <Card
              title="Languages"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of volunteer scientists, based on languages">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                languagesData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "languageBar",
                        languagesData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of volunteer scientists, based on languages.",
                        "Volunteer Scientists Language Distribution",
                        "Volunteer Scientists Languages",
                        "No of Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        languagesData,
                        "Volunteer Scientists Language Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {languagesData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={languagesData.filter((item) => item.value > 0)}
                  xLabel="type"
                  yLabel="value"
                  color="languageBar"
                  xAxisLabel="Volunteer Scientist Languages"
                  yAxisLabel="No of Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Card
              title="Age Range"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of volunteer scientists, based on citizen scientist age range">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                ageRangeData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "ageBar",
                        ageRangeData,
                        reportTypeEnum.BAR,
                        "Demographic analysis of volunteer scientist, based on participant age range.",
                        "Volunteer Scientist Age Range Distribution",
                        "Age range",
                        "No of Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        ageRangeData,
                        "Volunteer Scientist Age Range Distribution",
                        reportTypeEnum.BAR
                      )
                    }
                  />,
                ]
              }
            >
              {ageRangeData?.length == 0 ? (
                <Empty />
              ) : (
                <BarChart
                  color="ageBar"
                  data={ageRangeData.filter((item) => item.value > 0)}
                  xField="type"
                  yField="value"
                  xAxisLabel="Age range"
                  yAxisLabel="No of Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Disability"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of volunteer scientists, based on disability">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                disabilityData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "disabilityDoughnut",
                        disabilityData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of volunteer scientists, based on disability.",
                        "Volunteer Scientists Disability Distribution"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        disabilityData,
                        "Volunteer Scientists Disability Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {disabilityData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={disabilityData.filter((item) => item.value > 0)}
                  color="disabilityDoughnut"
                  type="Disability"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab2() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of volunteer particiption in the Provinces"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={volunteerProvincialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerProvincialData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of volunteer particiption in the Provinces",
                        volunteerProvincialDistribution,
                        volunteerProvincialData,
                        reportTypeEnum.GEO_PROVINCES,
                        "volunteers"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerProvincialDistribution,
                        volunteerProvincialData,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceProvinceMap
                data={volunteerProvincialData}
                hoverText={volunteerProvincialDistribution}
                dataSource={"volunteers"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>

        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of volunteer particiption in the Municipal boundaries"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={volunteerDistrictDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerDistrictData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of volunteer particiption in the Municipal boundaries",
                        volunteerDistrictDistribution,
                        volunteerDistrictData,
                        reportTypeEnum.GEO_MUNICIPALS,
                        "volunteer"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerDistrictData,
                        volunteerDistrictDistribution,
                        reportTypeEnum.GEO_MUNICIPALS
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceDistrictMap
                data={volunteerDistrictData}
                hoverText={volunteerDistrictDistribution}
                dataSource={"volunteer"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab3() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              title="Qualifications"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Volunteers per qualification">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerQualificationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "participantType",
                        volunteerQualificationData,
                        reportTypeEnum.COLUMN,
                        "Volunteers per qualification",
                        "Volunteer Scientists Qualifications",
                        "Volunteer Scientists Qualification Level",
                        "Total Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerQualificationData,
                        "Volunteer Scientists Qualifications",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {volunteerQualificationData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={volunteerQualificationData.filter(
                    (item) => item.value > 0
                  )}
                  xLabel="type"
                  yLabel="value"
                  color="ageDougnut"
                  xAxisLabel="Volunteer Scientists Qualification Level"
                  yAxisLabel="Total Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row span={25} style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={24}></Col>
        </Row>
        <Row span={25} style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12}>
            <Card
              title="Occupations"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Total volunteer per occupation">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerOccupation.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceBar",
                        volunteerOccupation,
                        reportTypeEnum.BAR,
                        "Total volunteer per occupation",
                        "Total volunteer per occupation",
                        "Volunteer occupation",
                        "No of Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerOccupation,
                        "Volunteer Scientist Role",
                        reportTypeEnum.BAR
                      )
                    }
                  />,
                ]
              }
            >
              {volunteerOccupation?.length == 0 ? (
                <Empty />
              ) : (
                <BarChart
                  color="raceBar"
                  data={volunteerOccupation.filter((item) => item.value > 0)}
                  xField="type"
                  yField="value"
                  xAxisLabel="Volunteer occupation"
                  yAxisLabel="No of Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Sector"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Volunteers per economic sector">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                sectorData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "participantType",
                        sectorData,
                        reportTypeEnum.COLUMN,
                        "Volunteers per economic sector.",
                        "Volunteer Scientists Sector Distribution",
                        "Volunteer Scientists sector",
                        "No of Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        sectorData,
                        "Volunteer Scientists Sector Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {sectorData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={sectorData.filter((item) => item.value > 0)}
                  xLabel="type"
                  yLabel="value"
                  color="ageDougnut"
                  xAxisLabel="Volunteer Scientist sector"
                  yAxisLabel="No of Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab4() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12}>
            <Card
              title="Volunteer Roles"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Volunteer Scientist per role">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerRoles.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceBar",
                        volunteerRoles,
                        reportTypeEnum.BAR,
                        "Volunteer Scientist per role",
                        "Volunteer Scientist per role",
                        "Volunteer Scientist per role",
                        "No of Volunteer Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerRoles,
                        "Volunteer Scientist per role",
                        reportTypeEnum.BAR
                      )
                    }
                  />,
                ]
              }
            >
              {volunteerRoles?.length == 0 ? (
                <Empty />
              ) : (
                <BarChart
                  color="raceBar"
                  data={volunteerRoles.filter((item) => item.value > 0)}
                  xField="type"
                  yField="value"
                  xAxisLabel="Volunteer Scientist per role"
                  yAxisLabel="No of Volunteer Scientists"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Reason for volunteering"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Volunteers based on reason for volunteering">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerMotivationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "reasonBar",
                        volunteerMotivationData,
                        reportTypeEnum.BAR,
                        "Volunteers based on reason for volunteering",
                        "Volunteers based on reason for volunteering",
                        "Volunteer Scientist per reason",
                        "No of Volunteer Scientist"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerMotivationData,
                        "Volunteers based on reason for volunteering",
                        reportTypeEnum.BAR
                      )
                    }
                  />,
                ]
              }
            >
              {volunteerMotivationData?.length == 0 ? (
                <Empty />
              ) : (
                <BarChart
                  color="reasonBar"
                  data={volunteerMotivationData.filter(
                    (item) => item.value > 0
                  )}
                  xField="type"
                  yField="value"
                  xAxisLabel="Volunteer Scientist per reason"
                  yAxisLabel="No of Volunteer Scientist"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab5() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={12} md={24}>
            <Card
              title="Volunteer Growth and Retention"
              style={{ height: "auto" }}
              extra={
                <Tooltip title="The total number of active volunteers and the percentage of active volunteers that remains the same over a number of years.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                volunteerGrowth.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "",
                        volunteerGrowth,
                        reportTypeEnum.DUALAXES,
                        "The total number of active volunteers and the percentage of active volunteers that remains the same over a number of years.",
                        "Volunteer Growth and Retention",
                        "Year",
                        "",
                        "type",
                        true
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        volunteerGrowth,
                        "Volunteer Growth and Retention",
                        reportTypeEnum.DUALAXES
                      )
                    }
                  />,
                ]
              }
            >
              {volunteerGrowth?.length === 0 ? (
                <Empty />
              ) : (
                <DualAxesChart
                  data={volunteerGrowth?.filter((item) => item.value >= 0)}
                  type="Volunteer"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  const tabList = [
    {
      key: "Volunteer demographic",
      label: "Demographic distribution",
      children: <Tab1 />,
      activeKey: true,
    },
    {
      key: "Volunteer geographic",
      label: "Volunteer geographic distribution",
      children: <Tab2 />,
    },
    {
      key: "Professional experience",
      label: "Professional Experience",
      children: <Tab3 />,
    },
    {
      key: "Volunteerism information",
      label: "Volunteerism Information",
      children: <Tab4 />,
    },
    {
      key: "Growth",
      label: "Volunteer Growth",
      children: <Tab5 />,
    },
  ];

  const onTabChange = (key) => {
    switch (key) {
      case "Volunteer demographic":
        getVolunteerDemographicsDisability(reportYear, filterId)
        getVolunteerDemographicsGender(reportYear, filterId)
        getVolunteerDemographicsRace(reportYear, filterId)
        getVolunteerDemographicAgeRange(reportYear,filterId);
        getVolunteerDemographicsLanguages(reportYear,filterId);
        break;
      case "Volunteer geographic":
        getVolunteerProvincial(reportYear, filterId);
        getVolunteerMunicipal(reportYear, filterId);
        break;
      case "Professional experience":
        getVolunteerQualification(reportYear, filterId)
        getVolunteerOccupation(reportYear, filterId);
        getVolunteerSectors(reportYear, filterId);
        break;
      case "Volunteerism information":
        getvolunteerMotivationData(reportYear, filterId);
        getVolunteerRole(reportYear, filterId);
        break;
      case "Growth":
         getVolunteerScienceGrowth(reportYear, filterId);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <div className="report-nys-content">
        {/* <h2 className="report-heading">{`${props.eventType} Report`}</h2> */}
        <h2 className="report-heading">Vounteer Scientist Report</h2>
        <div className="reportYear">
          <Row
            ustify="center" align="middle"
          >
            <Col
              xs={24}
              md={11}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Financial year : &nbsp;
                  <Select
                    // style={{ width: "65%" }}
                    placeholder="Please select financial year"
                    onChange={onYearChange}
                    loading={!financialYears.length}
                    value={reportYear}
                    size="large"
                  >
                    {financialYears?.map((year) => {
                      return (
                        <Option key={year.id} value={year.id}>
                          {year.value}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </Col>
            <Col
              xs={3}
              md={3}
              sm={3}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                ></div>
              </div>
            </Col>
          </Row>
        </div>
        <br />
      </div>
      <div className="space"></div>
      <Tabs
        type="card"
        onChange={onTabChange}
        items={tabList}
        className="report-tabs"
        key="report-tab"
      />
      <ReportTemplate
        onCancel={handlePrintCancel}
        reportOutProps={reportOutProps}
        show={show}
        key="reportTemplateEvents"
        isGeo={isGeo}
      />
    </>
  );
};
